
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useScrollToTop } from "@/hooks/useScrollToTop";
import { SocialMediaHead } from "@/components/shared/SocialMediaHead";
import Index from "./pages/Index";
import About from "./pages/About";
import Episodes from "./pages/Episodes";
import Characters from "./pages/Characters";
import CharacterDetail from "./pages/CharacterDetail";
import Activities from "./pages/Activities";
import Culture from "./pages/Culture";
import Partners from "./pages/Partners";
import Support from "./pages/Support";
import MeetOurSponsors from "./pages/MeetOurSponsors";
import MeetOurDonors from "./pages/MeetOurDonors";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";
import Privacy from "./pages/legal/Privacy";
import Terms from "./pages/legal/Terms";
import Cookies from "./pages/legal/Cookies";

const queryClient = new QueryClient();

// Component to handle scroll-to-top functionality
const ScrollHandler = () => {
  useScrollToTop();
  return null;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollHandler />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about" element={<About />} />
          <Route path="/episodes" element={<Episodes />} />
          <Route path="/characters" element={<Characters />} />
          <Route path="/characters/:characterSlug" element={<CharacterDetail />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/culture" element={<Culture />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/support" element={<Support />} />
          <Route path="/sponsor" element={<Support />} /> {/* Legacy redirect */}
          <Route path="/meet-our-sponsors" element={<MeetOurSponsors />} />
          <Route path="/meet-our-donors" element={<MeetOurDonors />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/legal/privacy" element={<Privacy />} />
          <Route path="/legal/terms" element={<Terms />} />
          <Route path="/legal/cookies" element={<Cookies />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
